/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { chevronUp } from "../assets/chevron-up";
import { Icon, type IconBaseProps } from "../icon";

export const IconChevronUp = (props: IconBaseProps) => <Icon {...props} svg={chevronUp} />;

IconChevronUp.displayName = "IconChevronUp";
